// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import {
  get as _get,
  includes as _includes,
  map as _map,
  parseInt as _parseInt,
  trim as _trim,
} from 'lodash-es';
import $ from 'jquery';
import {dispatchLayoutChange, getQueryVar} from '../_util';
import themeCommon from './_common';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'topics-catalog';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class TopicsCatalog {
  constructor(el) {
    this._filterGroup = false;
    this._filterItems = [];
    this._searchErrorMsg = '';

    this.el = el;
    this.$groupBtns = $(el).find(`.${baseClass}__group-btn`);
    this.$groupReset = $(el).find(`.${baseClass}__group-reset`);
    this.$searchForm = $(el).find(`.${baseClass}__search`);
    this.$searchFormTitle = $(el).find(`.${baseClass}__search-title`);
    this.$searchFormInput = this.$searchForm.find('[name="s"]');
    this.$searchError = $(el).find(`.${baseClass}__search-error`);
    this.$headerSpacing = $(el).find(`.${baseClass}__space-before-heading`);
    this.$entrance = $(el).find(`.${baseClass}__entrance`);
    this.$groups = $(el).find(`.${baseClass}__group`);

    this._searchFormInitialTitle = this.$searchFormTitle.text().trim();

    this.$groupBtns.on('click', (e) => {
      const btnEl = e.currentTarget;
      this.filterGroup = btnEl.dataset.id;


    }).prop('disabled', false);

    this.$groupReset.on('click', 'button', () => {
      this.filterGroup = false;
    });

    this.$searchFormInput.on('search', (e) => {
      if (_trim(e.target.value).length !== 0) {
        return;
      }

      // User cleared search
      this.filterItems = [];
    });

    this.$searchForm.on('submit', (e) => {
      e.preventDefault();

      if (this.getSearchQuery() === '') {
        this.filterItems = [];

        return;
      }

      const formEl = e.currentTarget;
      const formData = new FormData(formEl);

      this.searchErrorMsg = '';
      this.toggleBusy(true);

      $.ajax(formEl.getAttribute('action'), {
        data: formData,
        method: formEl.getAttribute('method'),
        processData: false,
        contentType: false,
        accept: 'application/json',
      }).done(({ success, message, data: topicIds } /* , textStatus, jqXHR */) => {
        if (success === false) {
          this.searchErrorMsg = message || "Unbekannter Fehler";

          return;
        }

        this.filterItems = topicIds || [];
      }).fail((jqXHR /* , textStatus, error */) => {
        let response = _trim(_get(jqXHR, 'responseText'));
        response = response.length ? response : 'Unbekannter Fehler';
        this.searchErrorMsg = response;
      }).always(() => {
        this.toggleBusy(false);
      });

    }).find(':input').prop('disabled', false);

    this.$entrance.find('button').on('click', (e) => {
      const btnEl = e.currentTarget;
      this.filterGroup = btnEl.dataset.id;
      themeCommon.smoothScrollTo(this.$headerSpacing, 0);
    }).prop('disabled', false);

    this.filterGroup = getQueryVar('sector');

    this.queryVarFilter();
  }

  queryVarFilter() {
    const filter = getQueryVar('filter');
    if (filter != null) {
      for(let item of this.$groupBtns) {
        let bntText = item.querySelector('.col').textContent.trim().replaceAll('+', '&nbsp;');

        if(bntText === filter) {
          item.closest('button').click();
        }
      }
    }
  }

  getSearchQuery() {
    return _trim(this.$searchFormInput.val());
  }

  hasFilterGroup() {
    return (this.filterGroup !== false);
  }

  hasFilterItems() {
    return !!this.filterItems.length;
  }

  hasFilter() {
    return (this.hasFilterGroup() || this.hasFilterItems());
  }

  toggleBusy(busy) {
    $(this.el).toggleClass('busy', !!busy)
      .find(':input').not('.no-lock')
      .prop('disabled', !!busy);
  }

  updateGroupButtons() {
    this.$groupBtns.removeClass('active')
      .filter(`[data-id="${this.filterGroup}"]`).addClass('active');
    this.$groupReset.toggleClass('d-none', !this.hasFilterGroup());
  }

  updateEntrance() {
    this.$entrance.toggleClass('d-none', this.hasFilter());
  }

  updateGroups() {
    const $items = this.$groups.find('li');
    $items.add(this.$groups).addClass('d-none');

    if (this.hasFilterItems()) {
      $items.filter((i, e) => {
        const id = parseInt(e.dataset.id, 10);

        return _includes(this.filterItems, id);
      }).removeClass('d-none');
    }

    if (this.hasFilterGroup() && this.hasFilterItems() === false) {
      this.$groups
           .filter(`[data-id="${this.filterGroup}"]`)
           .find($items)
           .removeClass('d-none');
    }

    this.$groups
        .filter((i, e) => !!$(e).find('li').not('.d-none').length)
        .filter((i, e) => this.hasFilterGroup() === false || $(e).data('id') === this.filterGroup)
        .removeClass('d-none');
  }

  updateSearchTitle() {
    const groupTitle = $(`[data-id="${this.filterGroup}"] .${baseClass}__group-title`).first().text().trim();

    if (!groupTitle) {
      this.$searchFormTitle.text(this._searchFormInitialTitle);

      return;
    }

    this.$searchFormTitle.text(`Suche in "${groupTitle}"`);
  }

  get filterGroup() {
    return this._filterGroup;
  }

  set filterGroup(val) {
    const groupId = parseInt(val, 10);
    this._filterGroup = Number.isNaN(groupId) ? false : groupId;

    this.updateEntrance();
    this.updateGroups();
    this.updateGroupButtons();
    this.updateSearchTitle();
    dispatchLayoutChange();
  }

  get filterItems() {
    return this._filterItems;
  }

  set filterItems(ids) {
    this._filterItems = _map(ids, _parseInt);

    this.updateEntrance();
    this.updateGroups();
    this.updateGroupButtons();
    dispatchLayoutChange();
  }

  get searchErrorMsg() {
    return this._searchErrorMsg;
  }

  set searchErrorMsg(str) {
    const msg = _trim(str);
    this._searchErrorMsg = msg;
    this.$searchError.text(msg).toggleClass('d-none', !msg.length);
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new TopicsCatalog(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
